export class ReferenceEventRequest {
  id: string;
  session: string;
  layout: string;
  flow: string;
}
